import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const setUser = createAsyncThunk(
  "setUser",
  async (user, { rejectWithValue, fulfillWithValue }) => {
    return fulfillWithValue(user);
  }
);

export const removeUser = createAsyncThunk(
  "removeUser",
  async (user = {}, { rejectWithValue, fulfillWithValue }) => {
    return fulfillWithValue(user);
  }
);

export const updateUserInfo = createAsyncThunk(
  "updateUserInfo",
  async (user, { rejectWithValue, fulfillWithValue }) => {
    return fulfillWithValue(user);
  }
);

const userSlice = createSlice({
  name: "user",
  initialState: {
    user: {},
  },
  extraReducers: (builder) => {
    builder.addCase(setUser.fulfilled, (state, action) => {
      return (state = {
        ...state,
        user: action.payload,
      });
    });
    builder.addCase(removeUser.fulfilled, (state, action) => {
      return (state = {
        ...state,
        user: action.payload,
      });
    });
    builder.addCase(updateUserInfo.fulfilled, (state, action) => {
      return (state = {
        ...state,
        user: action.payload,
      });
    });
  },
});

export default userSlice.reducer;
